export default __webpack_public_path__ + "static/media/ic_tab_blog.14fc812f.svg";